import { CustomPage } from '../model';
import { getAPILocale } from '@/utils';
import { graphql } from 'gql.tada';
import { pageFragment } from '@/utils/graphql/pageFragment';

export const pagesVariables = ({
  pageType,
  slug,
  channelId,
  pageLayoutIdentifier,
  languageCode,
}: {
  pageType?: CustomPage['pageType'];
  slug?: string;
  channelId?: string;
  pageLayoutIdentifier?: CustomPage['pageLayoutIdentifier'];
  languageCode?: string;
}) => {
  const where: any = {
    platform: {
      equals: 'website',
    },
  };
  if (pageLayoutIdentifier) {
    where.pageLayoutIdentifier = {
      equals: pageLayoutIdentifier,
    };
  }
  if (channelId) {
    where.channel = {
      equals: channelId,
    };
  }
  if (pageType) {
    where.pageType = {
      equals: pageType,
    };
  }
  if (slug) {
    where.slug = {
      equals: decodeURIComponent(slug),
    };
  }
  return {
    where: where,
    locale: getAPILocale(languageCode) ?? 'en',
  };
};

// @ts-ignore
export const GET_PAGES = graphql(`
  query GetAllPages($where: Page_where, $locale: LocaleInputType) {
    ${pageFragment}
  }
`);

export const GET_PAGE_WITH_OPINION_FEATURE_PAGES_MENU = graphql(`
  query GetOpinionFeaturePagesMenu(
    $opinionWhere: Page_where
    $featureWhere: Page_where
    $locale: LocaleInputType
  ) {
    OpinionPages: Pages(where: $opinionWhere, locale: $locale) {
      docs {
        slug
      }
    }
    FeaturePages: Pages(where: $featureWhere, locale: $locale) {
      docs {
        slug
      }
    }
  }
`);
